import React, { Suspense, lazy } from 'react'
import { Modal, useBreakpoints } from '@web/walter-ui-kit'
import SuspenseLoader from '~components/SuspenseLoader'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'

const Content = lazy(() => import('./Content'))

function TransactionDetailsModal() {
    const { hide, isOpen, setData, data } = useModal(ModalTypes.transactionDetails)
    const { isMobile } = useBreakpoints()

    const onModalCloseHandler = () => {
        hide()
        setData({})
    }

    return (
        <Modal
            key={data?.tx?.id}
            type={isMobile ? 'standard' : 'dialog'}
            maxHeightMobile
            withHeaderBorder={false}
            isOpen={isOpen}
            withBackButton={isMobile}
            onBackButtonClick={hide}
            onClose={onModalCloseHandler}
            dataPointer="transaction_details_modal"
        >
            <Suspense fallback={<SuspenseLoader />}>
                <Content
                    tx={data?.tx}
                    swapPageLocationState={data?.swapPageLocationState}
                    onClose={onModalCloseHandler}
                    onActionClick={data?.onActionClick}
                />
            </Suspense>
        </Modal>
    )
}

export default TransactionDetailsModal
